import { CalculationMetricTable } from 'modules/components/layer25';



export const FC = () => {
  return (
    <CalculationMetricTable.FC showChatBubble />
  );
};
